import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";
//import Escudo from "../../../assets/Escudo.jpg";

const componentRef = React.createRef();
var QRCode = require("qrcode.react");

class Licencia extends React.Component {
  //<Licencia modalLicencia=this.state.modalLicencia working=this.state.working licencia=this.state.licencia date=this.state.date/>
  render() {
    return (
      <Modal isOpen={this.props.modalLicencia} modalClassName="modal-message">
        <ModalHeader>
          <div>
            Folio de Licencia: {this.props.licencia.folio}
            <button
              type="button"
              className="close"
              onClick={this.props.change}
              style={{ position: "fixed", right: "21%" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              {/*Aqui se muestra licencia******************************************************/}

              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                }}
              >
                {/*"C:\Users\celes\Documents\GitHub\sinaip\client\public\assets\Escudo.jpg" */}
                <div style={{ textAlign: "left", margin: "3%" }}>
                  <table style={{ width: "100%", tableLayout: "auto" }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td style={{ textAlign: "right", color: "black" }}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="75%">
                          {/*this.props.licencia.tramite_id === "1" ||
                          this.props.licencia.tramite_id === "2" ? (
                            <h5
                              style={{
                                textAlign: "right",
                                marginRight: "15%",
                                color: "black",
                              }}
                            >
                              {this.props.licencia.tramite}
                            </h5>
                          ) : (
                            <h5
                              style={{
                                textAlign: "right",
                                margin: "8%",
                                color: "black",
                              }}
                            >
                              {this.props.licencia.tramite}{" "}
                              {this.props.licencia.nacional}
                            </h5>
                            )*/}
                        </td>
                        <td width="25%">
                          <div
                            style={{
                              textAlign: "right",
                              margin: "8%",
                              color: "black",
                            }}
                          >
                            <QRCode
                              size="100"
                              value={
                                "id: " +
                                this.props.licencia.licencia_id +
                                "\n" +
                                "guid: " +
                                this.props.licencia.guid +
                                "\n" +
                                "fecha de vencimiento:" +
                                this.props.licencia.fecha_vencimiento
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h5 style={{ textAlign: "center", margin: "8%" }}> 
                  INSTITUTO DE PROTECCIÓN Y SANIDAD AGROPECUARIA 
                  <br/>DIRECCIÓN DE SALUD ANIMAL
                  <br/>DEPARTAMENTO DE REGULACIÓN Y CONTROL DE INSUMOS PECUARIOS
                </h5>
                <p style={{ textAlign: "center", margin: "8%" }}>
                  Licencia No. {this.props.licencia.folio}
                </p>
                {this.props.licencia.tramite_id === "1" ||
                this.props.licencia.tramite_id === "2" ? (
                  <div>
                    <p style={{ textAlign: "justify" }}>
                      {this.props.licencia.texto}{" "}
                    </p>
                    <p>
                      <b>Nombre: </b>
                      {this.props.licencia.nombre_regente}
                    </p>
                    <p>
                      <b>Profesiones: </b>
                      {this.props.licencia.profesion}
                    </p>
                    {this.props.licencia.tramite_id === "1" ? (
                      <p>
                        <b>Código IPSA: </b>
                        {this.props.licencia.codigo_ipsa}
                      </p>
                    ) : null}
                    <p>
                      <b>Código de regencia: </b>
                      {this.props.licencia.codigo_regencia}
                    </p>
                  </div>
                ) : (
                  <div>
                    <p style={{ textAlign: "justify" }}>
                      {this.props.licencia.texto} {this.props.licencia.nombre}
                    </p>

                    {this.props.licencia.nacional === "Nacional" ? (
                      <div>
                        <p>
                          <b>Representante Legal: </b>
                          {this.props.licencia.representante_legal}
                        </p>
                        <p>
                          <b>Regente: </b>
                          {this.props.licencia.regente}
                        </p>
                        <p>
                          <b>País: </b>
                          {this.props.licencia.pais}
                        </p>
                        <p>
                          <b>Dirección:</b> Departamento de{" "}
                          {this.props.licencia.departamento}, municipio de{" "}
                          {this.props.licencia.municipio},{" "}
                          {this.props.licencia.direccion}.
                        </p>
                        <p>
                          <b>Código del establecimiento: </b>
                          {this.props.licencia.codigo_est}
                        </p>
                        <p>
                          <b>Naturaleza de la actividad </b>
                          {this.props.licencia.actividad}
                          {this.props.licencia.tipo_id === "1" ||
                          this.props.licencia.tipo_id === "2" ?  " de medicamentos veterinarios y productos afines" : " de productos utilizados en alimentación animal"}
                        </p>
                        <p>
                          <b>Fecha de registro: </b>
                          {this.props.licencia.fecha_hora_emision}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p>
                          <b>Representante Legal: </b>
                          {this.props.licencia.representante_legal}
                        </p>
                        <p>
                          <b>Regente: </b>
                          {this.props.licencia.regente}
                        </p>
                        <p>
                          <b>País: </b>
                          {this.props.licencia.pais}
                        </p>
                        <p>
                          <b>Código del establecimiento: </b>
                          {this.props.licencia.codigo_est}
                        </p>
                        <p>
                          <b>Naturaleza de la actividad: </b>
                          {this.props.licencia.actividad} 
                         
                        </p>
                      </div>
                    )}
                  </div>
                )}
                <p>
                  <b>Fecha de vencimiento de licencia: </b>{" "}
                  {this.props.licencia.fecha_vencimiento}
                </p>
                {/* <p>
                    Colocar copia de esta licencia en un lugar visible del
                    establecimiento
                  </p> */}
                <p>
                  {/* {this.props.licencia.lugar_emision}, {this.props.date}. */}
                  <b>Managua, Nicaragua</b>{" "}
                  {this.props.licencia.fecha_hora_emision}
                </p>
                {/* this.props.licencia.firma !== null? 
                  <img
                    style={{ textAlign: "center", margin: "8%" }}
                    src={this.props.licencia.firma}
                  />
                  : null*/}
                <p
                  style={{
                    textAlign: "center",
                    margin: "8%",
                    marginTop: "15em",
                  }}
                >
                  <center>
                    <div
                      style={{ borderBottom: "1px solid #333", width: "50%" }}
                    ></div>
                    <div>{this.props.licencia.nombre_firma}</div>
                  </center>
                  Director DISAAN
                </p>
                {this.props.reposicion ? (
                  <p style={{ textAlign: "justify" }}>
                    <b>REPOSICIÓN</b>
                  </p>
                ) : null}
              </form>
            </div>
            <hr />
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button id="btn-imprimir" className="btn btn-primary m-r-5">
                Imprimir
              </button>
            )}
            onBeforeGetContent={() =>
              this.props.imprimir(
                this.props.licencia.licencia_id,
                this.props.licencia.tramite_id,
                this.props.licencia.impresiones
              )
            }
          />
          <button className="btn btn-danger" onClick={this.props.change}>
            Regresar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default Licencia;
